import { render } from "./render-html.vue?vue&type=template&id=51b6ed3d"
import script from "./render-html.vue?vue&type=script&lang=js"
export * from "./render-html.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__